import { formatEta } from '../lib/format'
import type { QueueStats } from '../upload/useUploadQueue'

/**
 * De banner "3 van 8 geüpload" met de voortgangsbalk. Staat boven de galerij
 * (ronde 6A, 7A) en in het kop van het uploadstatus-scherm (10A, 11A) — daar
 * met een regel uitleg erbij, vandaar `detail`.
 */
export function UploadNotice({
  stats,
  detail,
  onClick,
}: {
  stats: QueueStats
  detail?: string
  onClick?: () => void
}) {
  const eta = formatEta(stats.etaSeconds)

  const body = (
    <>
      <div className="flex items-baseline justify-between gap-3">
        <span className="flex items-center gap-2.25 text-sm font-medium sm:text-[15px] sm:font-semibold">
          {stats.busy && (
            <span
              aria-hidden="true"
              className="bg-accent inline-block size-2 shrink-0 animate-pulse rounded-full"
            />
          )}
          {stats.done} van {stats.total} geüpload
        </span>

        <span className="text-ink-soft text-[13px]">
          {eta ?? (stats.busy ? 'bezig…' : 'klaar')}
        </span>
      </div>

      <div
        className="bg-notice-line mt-3 h-1 overflow-hidden rounded-full sm:h-1.25"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(stats.progress * 100)}
      >
        <div
          className="bg-accent h-full transition-[width] duration-300"
          style={{ width: `${Math.round(stats.progress * 100)}%` }}
        />
      </div>

      {detail && <p className="text-ink-soft mt-2.75 text-[13px] leading-[1.5]">{detail}</p>}
    </>
  )

  const shell =
    'w-full rounded-notice border border-notice-line bg-notice p-4 text-left ' +
    (detail ? '' : 'py-3.25')

  return onClick ? (
    <button type="button" onClick={onClick} className={shell + ' active:scale-[0.995]'}>
      {body}
    </button>
  ) : (
    <div className={shell}>{body}</div>
  )
}
